// @ts-nocheck

import {combineReducers} from 'redux';

import type {Action as PhoneNumberSetAction} from 'src/action-creators/chat/phone-number-sets';
import type {ReceiveAction as ReceiveKeywordSearchAction} from 'src/action-creators/chat/keyword-search';
import {
  State as PhoneNumberSetState,
  default as phoneNumberSets,
} from './phone-number-sets';
import {
  State as AllowedPhoneNumbersState,
  default as allowedPhoneNumbers,
} from './allowed-phone-numbers';
import {
  State as MultiNumberInbox,
  default as multiNumberInbox,
} from './multi-number-inbox';
import {
  State as KeywordSearchState,
  default as keywordSearch,
} from './keyword-search';
import {State as FileUploadState, default as fileUpload} from './file-upload';
import {State as PanelsState, default as panels} from './panels';
import {State as QueuesState, default as queues} from './queues';
import {
  State as LanguageTranslationState,
  default as languageTranslation,
} from './language-translation';


export type State = {
  phoneNumberSets: PhoneNumberSetState;
  allowedPhoneNumbers: AllowedPhoneNumbersState;
  multiNumberInbox: MultiNumberInbox;
  keywordSearch: KeywordSearchState;
  fileUpload: FileUploadState;
  panels: PanelsState;
  queues: QueuesState;
  languageTranslation: LanguageTranslationState;
};

type Action = PhoneNumberSetAction;

const reduce = combineReducers({
  phoneNumberSets,
  allowedPhoneNumbers,
  multiNumberInbox,
  keywordSearch,
  fileUpload,
  panels,
  queues,
  languageTranslation,
});
export default reduce;
